import React, { useEffect, useContext, useRef, useState } from "react";
import CategoryCard from "../../Components/CategoryCard";
import SearchBar from "../../Components/SearchBar";
import CategoriesListLoader from "../../Components/Loaders/CategoriesListLoader";
import { getCategories } from "../../config/services";
import OrgInfoContext from "../../Contexts/OrgInfo.context";
import InfiniteScroll from 'react-infinite-scroller';
import LoadingSkeletonCategory from "../../Components/LoadingSkeletonCategory";
import { useLocation } from "react-router-dom";

const CategoriesList = () => {
    const { orgInfo } = useContext(OrgInfoContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const rawSuperParentCategoryId = queryParams.has('spid')
        ? queryParams.get('spid')
        : queryParams.get('super_parent_category_id');
    const parsedSuperParentCategoryId = Number(rawSuperParentCategoryId);
    const superParentCategoryId = Number.isSafeInteger(parsedSuperParentCategoryId) && parsedSuperParentCategoryId > 0
        ? parsedSuperParentCategoryId
        : 0;
    const [categoriesData, setCategoriesData] = useState([]);
    const [pageInfo, setPageInfo] = useState({});
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [currentSearchStr, setCurrentSearchStr] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [hasSuperCategories, setHasSuperCategories] = useState(false);
    const categoryRequestRef = useRef(0);
    
    const selectedSuperCategoryName = superParentCategoryId
    ? (queryParams.get('category') || '').trim()
    : "";

    const APIGetCategories = async (currentPageInfo = pageInfo, currentCategories = categoriesData) => {
        const requestId = ++categoryRequestRef.current;
        const getCategoriesData = await getCategories(currentPageInfo, orgInfo.store_url, 0, currentSearchStr, superParentCategoryId);
        if (requestId !== categoryRequestRef.current) {
            return;
        }
        // console.log('[CategoriesList.js] getCategoriesData >', getCategoriesData);
        setIsLoading(false);
        if (getCategoriesData.status) {
            if (!currentSearchStr && !superParentCategoryId && !currentPageInfo?.next) {
                setHasSuperCategories(getCategoriesData.data.some(category => Number(category.is_super_parent) === 1));
            }
            const existingData = [...currentCategories, ...getCategoriesData.data];
            setCategoriesData(existingData);
            setPageInfo(getCategoriesData.page);
            setIsLoadingMore(false);

        }

    };
    useEffect(() => {
        document.title = "Categories | " + document.title;
    }, []);

    useEffect(() => {
        setPageInfo({});
        setCategoriesData([]);
        setIsLoadingMore(false);
        setIsLoading(true);
        APIGetCategories({}, []);
    }, [currentSearchStr, superParentCategoryId]);

    const loadFunc = () => {
        // console.log('[CategoriesList.js] loadFunc Called')
        if (!isLoadingMore && pageInfo?.next) {
            setIsLoadingMore(true);
            APIGetCategories();
        }
    };

    const searchHandle = (searchString = "") => {
        // console.log('[CategoriesList.js] searchHandle searchString >' + searchString)
        if (searchString !== currentSearchStr) {
            setPageInfo({});
            setCategoriesData([]);
            setCurrentSearchStr(searchString);
            setIsLoading(true);
            // APIGetCategories();
        }
    };

    const searchPlaceHolder = hasSuperCategories ? "Search in Super Category" : "Search in all Categories";
    const categoryListTitle = selectedSuperCategoryName
    || (hasSuperCategories ? "All Super Categories" : "All Categories");
    return (
        <>
            {isLoading ? <CategoriesListLoader /> : null}
            {<SearchBar currentSearchStr={currentSearchStr} placeHolder={searchPlaceHolder} searchFunctionName={"searchHandle"} searchHandle={searchHandle} />}
            { false && isLoading ? null :
                <section className="category-wrp product-listing-wrp search-wrapper">
                    <div className="container-fluid">
                        <h2>{categoryListTitle}</h2>
                        { isLoading ? <LoadingSkeletonCategory /> : null}
                        {
                            !categoriesData.length && !isLoading ?
                                <div className="not-found-block">
                                    <div className="found-box">
                                        <img src="/images/category-not-found.svg" alt="" />
                                        <h4>No {hasSuperCategories ? "Super" : ""} Category found</h4>
                                        <p>There is no {hasSuperCategories ? "Super" : ""} category added yet</p>
                                    </div>
                                </div>
                                :
                                <InfiniteScroll
                                    pageStart={0}
                                    loadMore={loadFunc}
                                    hasMore={true}
                                    threshold={50}
                                    useWindow={true}
                                    isReverse={false}
                                // loader={<div className="loader" key={0}>Loading ...</div>}
                                >
                                    <div className="row">
                                        {categoriesData.map((cat, ind) => (
                                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-6" key={ind}>
                                                <div className="women-box">

                                                    <CategoryCard categoryInfo={cat} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </InfiniteScroll>
                        }

                        {isLoadingMore ?
                            <div className="pro-lst-blks">
                                <div className="view-allpro">
                                    <a className="view-btn">Loading ...</a>
                                </div>
                            </div>
                            :
                            null
                        }
                        {
                            categoriesData.length ?
                                <>
                                    <br />
                                    <br />
                                </>
                                :
                                null
                        }

                    </div>
                </section>
            }
        </>
    );
};

export default CategoriesList;